import { render } from "./DashboardModeSwitch.vue?vue&type=template&id=492159a2"
import script from "./DashboardModeSwitch.vue?vue&type=script&lang=js"
export * from "./DashboardModeSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__